import React, { useState } from 'react';
import cn from 'classnames';
import Card from '../Card/Card';
import MemberProfile from '@components/MasterAccount/MemberProfile';
import SlaveBalanceData from '@components/MasterAccount/SlaveBalanceData';
import DeleteMebmerBtn from '@components/MasterAccount/DeleteMebmerBtn';

const DeleteMemberBlock = ({ balance, slaves, onClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const isMobile = () => window.innerWidth < 768;

  const handleClick = () => {
    if (isMobile()) {
      onClick();
    } else {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <div className={cn('delete-member-block', { open: isExpanded })}>
      <button className="arrow" onClick={handleClick}>
        <MemberProfile slaves={slaves} />
      </button>

      {isExpanded && (
        <>
          <SlaveBalanceData balance={balance} />
          <DeleteMebmerBtn />
        </>
      )}
    </div>
  );
};

export default DeleteMemberBlock;
